import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { CustomState } from "@midland-industries/Store/CustomerPartNumberReducer";
import loadCustomerPartByProductNumber from "@midland-industries/Store/Pages/CustomerPartNumber/Handlers/LoadCustomerPartByProductNumber";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const parts = state.customerParts;
    return {
        parts,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

const mapDispatchToProps = {
    loadCustomerPartByProductNumber,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProduct;

export interface ProductDetailsCustomerPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const customerPartNumberStyles: ProductDetailsCustomerPartNumberStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = customerPartNumberStyles;

const ProductDetailsCustomerPartNumber: React.FC<Props> = props => {
    const { loadCustomerPartByProductNumber, parts, product, isAuthenticated } = props;
    if (!isAuthenticated) {
        return null;
    }

    useEffect(() => {
        (() => {
            loadCustomerPartByProductNumber({
                productId: product.id,
                erpNumber: product.productNumber,
            });
        })();
    }, []);

    const customerPart = parts?.byId[product.id];

    if (customerPart === undefined) {
        return null;
    }

    if (customerPart.customerPartNumber === "") {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="customerProductNumber">
            <Typography {...styles.labelText}>{translate("My Part #")}</Typography>
            {customerPart.customerPartNumber}
        </Typography>
    );
};

export default withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsCustomerPartNumber));
